module.exports = {"aggressive":"Aggressive","unfriendly":"Unfriendly","neutral":"Neutral","friendly":"Friendly","awakened":"Awakenend"};